var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationFaq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 57c-3.309 0-6-2.691-6-6 0-4.906-1.461-6.597-3.007-8.386C29.521 40.911 28 39.15 28 35c0-6.616 5.383-12 12-12s12 5 12 12h-2c0-6-4.486-10-10-10s-10 4.486-10 10c0 3.405 1.162 4.75 2.506 6.306C34.144 43.201 36 45.35 36 51c0 2.206 1.794 4 4 4s4-2 4-4h2c0 3-2.691 6-6 6",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 49c-2.206 0-4-2-4-4h2c0 1 .897 2 2 2s2-.897 2-2-.897-2-2-2h-2c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 4 8 8h-2c0-3-2.691-6-6-6s-6 2.692-6 6c0 3.309 2.691 6 6 6h2c2.206 0 4 1.794 4 4s-1.794 4-4 4",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M21 31h2v-2h-2zM16 28h2v-2h-2zM11 25h2v-2h-2zM29 23h2v-2h-2zM26 18h2v-2h-2zM23 13h2v-2h-2zM39 15h2v-2h-2zM39 20h2v-2h-2zM39 10h2V8h-2zM57 31h2v-2h-2zM62 28h2v-2h-2zM67 25h2v-2h-2zM49 23h2v-2h-2zM52 18h2v-2h-2zM55 13h2v-2h-2zM13 41h2v-2h-2zM18 41h2v-2h-2zM8 41h2v-2H8zM21 51h2v-2h-2zM16 54h2v-2h-2zM11 57h2v-2h-2zM29 59h2v-2h-2zM26 64h2v-2h-2zM23 69h2v-2h-2zM39 67h2v-2h-2zM39 62h2v-2h-2zM39 72h2v-2h-2zM65 41h2v-2h-2zM60 41h2v-2h-2zM70 41h2v-2h-2zM57 51h2v-2h-2zM62 54h2v-2h-2zM67 57h2v-2h-2zM49 59h2v-2h-2zM52 64h2v-2h-2zM55 69h2v-2h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationFaq;